import { render, staticRenderFns } from "./ProductOptionPage.vue?vue&type=template&id=ed854e92&"
import script from "./ProductOptionPage.vue?vue&type=script&lang=js&"
export * from "./ProductOptionPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports